import { render, staticRenderFns } from "./DataVolumeTrendsByPeriod.vue?vue&type=template&id=5e1e4e12&"
import script from "./DataVolumeTrendsByPeriod.vue?vue&type=script&lang=js&"
export * from "./DataVolumeTrendsByPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports